import { Outlet } from 'react-router-dom'

const Infrastructure = () => {
  return (
    <>
    <div><Outlet /></div>
    </>
  )
}

export default Infrastructure